// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentOutline = function (x) {
    return x;
};
var tsBridgeDocumentOutline = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentOutline")("__brandDocumentOutline"));
    }
};
var writeDocumentOutline = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentOutline = Data_Show.showString;
var readDocumentOutline = Simple_JSON.readString;
var ordDocumentOutline = Data_Ord.ordString;
var newtypeDocumentOutline = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentOutline = DocumentOutline;
var hasRuntimeTypeDocumentOutline = Untagged_TypeCheck.hasRuntimeTypeString;
var eqDocumentOutline = Data_Eq.eqString;
export {
    DocumentOutline,
    makeDocumentOutline,
    unwrap,
    newtypeDocumentOutline,
    eqDocumentOutline,
    ordDocumentOutline,
    showDocumentOutline,
    readDocumentOutline,
    writeDocumentOutline,
    hasRuntimeTypeDocumentOutline,
    tsBridgeDocumentOutline
};
//# sourceMappingURL=index.js.map
